import { useState, useEffect } from 'react';
import { api } from '../services/apiClient';

/** 打开面板期间每隔一段时间探测：后端 → RunningHub 域名是否可达（不扣费） */
const POLL_MS = 25000;

export function useRunningHubLinkIndicator(isOpen: boolean): boolean {
  const [linked, setLinked] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setLinked(false);
      return;
    }
    let cancelled = false;
    const run = async () => {
      const r = await api.checkRunningHubLink();
      if (!cancelled) setLinked(r.ok);
    };
    void run();
    const id = window.setInterval(() => void run(), POLL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [isOpen]);

  return linked;
}
